<div class="page page--statistics">
  <div class="page__container subaccounts-stats">
    <h1 class="page__title h2 mb-5">{{ 'reseller_stats_title' | translate }}</h1>
    <div class="my-5">
      <div ngbDropdown class="d-flex flex-column dropdown_small_device">
        <button class="btn btn-primary" id="dropdownAccountTab" #dropdown ngbDropdownToggle translate>reseller_stats_tab_graph</button>
        <div ngbDropdownMenu aria-labelledby="dropdownAccountTab">
          <button ngbDropdownItem translate (click)="nav.select(1); dropdown.innerText = $event.target.innerText">
            reseller_stats_tab_graph
          </button>
          <button ngbDropdownItem translate (click)="nav.select(2); dropdown.innerText = $event.target.innerText">
            reseller_stats_tab_table
          </button>
        </div>
      </div>
      <ul ngbNav #nav="ngbNav" class="nav-tabs nav_tab_large_device" [(activeId)]="activeId">
        <!--tab1-->
        <li [ngbNavItem]="1">
          <a ngbNavLink translate>reseller_stats_tab_graph</a>
          <ng-template ngbNavContent>
            <div class="row justify-content-between align-content-center container-fluid me-0">
              <ng-container>
                <div class="d-flex">
                  <label class="custom-label-sub" translate>menu_reseller</label>
                  <ng-container>
                    <ng-select
                      style="width: 205px;height:33px; margin-left: 10px;"
                      #subaccountSelected
                      bindValue="idSubaccountUser"
                      bindLabel="login"
                      class="form-control"
                      [(ngModel)]="idSubSelected"
                      [items]="subaccounts"
                      [clearable]="false"
                      (search)="onSearch($event)"
                      (change)="onChangeGrapichs()"
                      (scrollToEnd)="onScrollToEnd()"
                      (close)="onClose()"
                    >
                    </ng-select>
                  </ng-container>
                </div>
              </ng-container>
              <wsb-month-picker-range
                class="custom-width-date-picker"
                [(range)]="rangeFilter"
                (rangeChange)="onRangeChanged(rangeFilter)"
              ></wsb-month-picker-range>
              <wsb-slide-toggle
                [toggleControl]="dayMonthToggle"
                leftText="stats_choose_period_day"
                rightText="stats_choose_period_month"
                class="custom-height-style"
              ></wsb-slide-toggle>
            </div>

            <div class="mt-5">
              <table class="table">
                <tbody>
                  <td scope="col" class="col-md-2">{{ 'common_total' | translate }} : {{ formatNumber(totalsMessageTypes) }}</td>
                  <td *ngFor="let messageType of messageTypeStatistics; let i = index">
                    {{ messageType.label }} : {{ formatNumber(messageType.count) }}
                  </td>
                </tbody>
              </table>
            </div>

            <div class="mt-5">
              <div style="display: block;">
                <canvas
                  baseChart
                  width="400"
                  height="200"
                  *ngIf="lineChartOptions"
                  [datasets]="lineChartData"
                  [labels]="lineChartLabels"
                  [options]="lineChartOptions"
                  [legend]="lineChartLegend"
                  [type]="lineChartType"
                >
                </canvas>
              </div>
            </div>
          </ng-template>
        </li>
        <!-- end tab1 -->
        <!-- tab2-->
        <li [ngbNavItem]="2">
          <a ngbNavLink translate>reseller_stats_tab_table</a>
          <ng-template ngbNavContent>
            <div class="my-5">
              <wsb-atlas-grid
                #grid
                class="atlas-grid-simplest"
                class="mt-2 custom-input-element"
                [columnDefs]="tableColumnDefs"
                [options]="tableGridOptions"
                [@gridIsLoaded]="gridAnimationState"
                [components]="components"
              >
              </wsb-atlas-grid>
            </div>
          </ng-template>
        </li>
      </ul>
      <!--end  ul-->
    </div>
    <!-- end my-5-->
    <!-- show graphics-->
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
  </div>
  <!--end page__container -->
</div>
